module.exports = __webpack_public_path__ + "static/media/belt-replacement-red.5ac2fc6d.svg";